module.exports = __webpack_public_path__ + "static/media/now.a94f1f60.svg";